//error页面模块
const ErrorModule = r => require.ensure([], () => r(require('./404')), 'ErrorModule')

export default {
  path: '/error/404',
  name: '404',
  meta: { title: '404' },
  component: ErrorModule
}


// WEBPACK FOOTER //
// ./src/views/error/router.js